import { atom } from "recoil";

const tFA = atom({
  key: "tFA",
  default: true,
});

export default tFA;
